"use client";

import { useEffect, useRef, useState } from "react";

// Шутливые ответы на кнопки, за которыми в настоящем магазине была бы форма с контактами.
// Сайт демонстрационный: ничего не отправляется, контакты не спрашиваются.
export type JokeId = "subscribe" | "oneclick" | "order" | "adopt" | "contact" | "search" | "delivery";

const JOKES: Record<JokeId, { eyebrow: string; title: string; text: string; ok: string }> = {
  subscribe: {
    eyebrow: "«Голубиный вестник»",
    title: "Вы подписаны",
    text: "Вестник доставляет голубь. Адрес он знает сам, поэтому почту мы не спрашиваем. Первый выпуск прилетит, когда найдётся птенец.",
    ok: "Жду голубя",
  },
  oneclick: {
    eyebrow: "Быстрый заказ",
    title: "Заказ в один клик принят",
    text: "Телефон не нужен: оператор уже на карнизе и машет вам рукой. Магазин демонстрационный — товары настоящие только на фото, деньги не списываются.",
    ok: "Помахать в ответ",
  },
  order: {
    eyebrow: "Отдел снабжения",
    title: "Заказ принят учёным советом",
    text: "Это демо-магазин: корзина, скидки и подсчёт работают по-настоящему, а доставлять нечего. Адрес и телефон мы не спрашиваем — голубь-курьер всё равно их не запомнит.",
    ok: "Понятно, курлык",
  },
  adopt: {
    eyebrow: "Программа «Опекун голубя»",
    title: "Голубь выбран",
    text: "Он пока об этом не знает и, скорее всего, не узнает. Опекунство символическое: отчёты будут приходить в виде уверенного взгляда с ближайшего карниза.",
    ok: "Посмотреть на карниз",
  },
  contact: {
    eyebrow: "Отдел по работе с голубятнями",
    title: "Отдел на выезде",
    text: "Все сотрудники на крыше и не берут трубку. Контакты не оставляйте: институт всё равно найдёт вас сам, когда найдёт птенца.",
    ok: "Подожду",
  },
  delivery: {
    eyebrow: "Доставка и оплата",
    title: "Доставляем голубями",
    text: "Курьер института прилетает в любой город, но только к взрослым. Оплата — крошками при получении. На самом деле магазин демонстрационный: доставлять нечего, платить не нужно.",
    ok: "Ждать у окна",
  },
  search: {
    eyebrow: "Поиск по карте",
    title: "Адрес найден. Голуби — нет",
    text: "Голуби не сообщают адресов, а птенцы тем более. Отметьте наблюдение прямо на карте: кнопка «+ Добавить наблюдение» над ней.",
    ok: "Отметить на карте",
  },
};

const EVENT = "nii:joke";
export const joke = (id: JokeId) => window.dispatchEvent(new CustomEvent(EVENT, { detail: id }));

export default function Joke() {
  const dialog = useRef<HTMLDialogElement>(null);
  const [id, setId] = useState<JokeId>("subscribe");

  useEffect(() => {
    const open = (e: Event) => {
      setId((e as CustomEvent<JokeId>).detail);
      dialog.current?.showModal();
    };
    window.addEventListener(EVENT, open);
    return () => window.removeEventListener(EVENT, open);
  }, []);

  const j = JOKES[id];
  return (
    <dialog ref={dialog} className="modal joke" aria-labelledby="joke-title" onClick={(e) => e.target === e.currentTarget && dialog.current?.close()}>
      <button type="button" className="x" aria-label="Закрыть" onClick={() => dialog.current?.close()}>
        ×
      </button>
      <p className="eyebrow label">{j.eyebrow}</p>
      <h2 id="joke-title">{j.title}</h2>
      <p className="joke__text">{j.text}</p>
      <div className="actions">
        <button type="button" className="btn btn-p label" onClick={() => dialog.current?.close()}>
          {j.ok}
        </button>
      </div>
      <p className="joke__note">Демо-сайт: никакие данные не собираются и никуда не отправляются.</p>
    </dialog>
  );
}
